
<div class="padding-wrapper">

  <h1 class="margin-bottom-xl">{{ 'trains.title' | translate }}</h1>
  <div *ngIf="!loading && availableTrains.length" class="base-margin column gap">
    <h3>{{ 'trains.newSessions' | translate }}</h3>
    <div *ngIf="availableTrains.length === 0">
      {{ 'trains.emptyAvailable' | translate }}
    </div>
    <div *ngIf="availableTrains.length > 0" class="column gap">
      <app-train-card [apiCalling]="apiCalling" (goToDetails)="goToTrain($event)" *ngFor="let train of availableTrains"
                      (manage)="manageTrain($event)" [train]="train"></app-train-card>
    </div>
  </div>
  <div *ngIf="!loading && trains.length" class="base-margin column gap">
    <h3>{{ 'trains.inProgress' | translate }}</h3>
    <div *ngIf="trains.length === 0">
      {{ 'trains.emptyInProgress' | translate }}
    </div>
    <div *ngIf="trains.length > 0" class="column gap">
      <app-train-card [apiCalling]="apiCalling" (goToDetails)="goToTrain($event)" *ngFor="let train of trains"
                      (manage)="manageTrain($event)" [train]="train"></app-train-card>
    </div>
  </div>
  <div *ngIf="!loading && trainsCompleted.length" class="base-margin column gap">
    <h3>{{ (trainsCompleted.length > 1 ? 'trains.completedMany' : 'trains.completedOne') | translate }}</h3>
    <div *ngIf="trainsCompleted.length > 0" class="column gap">
      <app-train-card [apiCalling]="apiCalling" (goToDetails)="goToTrain($event)" *ngFor="let train of trainsCompleted"
                      (manage)="manageTrain($event)" [train]="train"></app-train-card>
    </div>
  </div>
  <app-spinner class="center-horizontally-by-margin" *ngIf="loading"></app-spinner>
</div>
